const STAFFING_TYPES = {
  UPDATE_STAFFING_DATA: "UPDATE_STAFFING_DATA",
  UPDATE_NOTIFICATION:"UPDATE_NOTIFICATION",
  CLEAR_STAFFING:"CLEAR_STAFFING",
  UPDATE_ROLE_DATA:"UPDATE_ROLE_DATA",
};


export default STAFFING_TYPES;
